import { all, call, put, select, takeEvery } from 'redux-saga/effects'

import * as actions from './actions'
import * as url from './url'
import * as helper from './helper'
import { api } from '../api'
import { util } from '../../util'
import { history } from '../../util/history'
import { constants } from '../../constants'
import { strings } from '../../context/LanguageContext/strings'

function* fetchProductByDraftId(action) {
    try {
        yield put(actions.productLoadingStart())
        let { data } = yield call(api, url.getProductByID(action.payload), 'GET', {
            hasCustomError: true,
        })
        const isModifiedAreaUpdated = yield select(util.isModifiedAreaAutoUpdated)
        const isFieldsAutoUpdated =
            isModifiedAreaUpdated === null && data.visibility === 'none'
                ? data.modified_area.includes('id_slin.upcs') ||
                  data.modified_area.includes('pricing.price_cap')
                : false
        data = helper.mapClonedProduct(data)
        const payload = {
            productDetails: data,
            isModifiedAreaAutoUpdated: isFieldsAutoUpdated,
        }
        yield put(actions.fetchProductDetailsSuccess(payload))
        yield put(actions.setSectionFlag(helper.extractSectionFlags(data)))
    } catch (error) {
        yield put(actions.setProductError(strings.PRODUCT_ERROR))
        yield put(actions.productLoadingEnd())
    }
}

function* fetchManageUpdates(action) {
    try {
        const isSideMenuOpened = yield select(util.isSideMenuOpened)
        if (isSideMenuOpened) {
            return
        }
        yield put(actions.productLoadingStart())
        let reqPayload = {}
        const { search, ...rest } = { ...action.payload }
        reqPayload = { ...rest, filter: search }
        const { data } = yield call(api, url.fetchManageUpdatesURL(), 'POST', reqPayload)
        const res = {
            ...data,
            products: data.data,
        }
        delete res.data
        yield put(actions.fetchManageUpdatesSuccess(res))
    } catch (error) {
        yield put(actions.productLoadingEnd())
        console.log('FETCH MANAGE UPDATES ERROR', error)
    }
}

function* fetchAvailableProductImages(action) {
    try {
        yield put(actions.startProductImageLoading())
        const { data } = yield call(api, url.getProductImages(action.payload), 'POST', null, {
            hasCustomError: true,
        })
        yield put(actions.setProductAvailableImages(data))
    } catch (error) {
        yield put(actions.setProductError(strings.UPLOAD_IMAGE_ERROR_SHORT))
        yield put(actions.stopProductImageLoading())
    }
}

function* fetchNutritionContains() {
    try {
        yield put(actions.containsLoadingStart())
        const { contains_loading } = yield select(({ products }) =>
            products.get('contains_loading')
        )
        if (!contains_loading) {
            const { data } = yield call(api, url.getContainsList(), 'GET')
            yield put(actions.setNutritionContains(data))
        }
        yield put(actions.containsLoadingEnd())
    } catch (error) {
        yield put(actions.containsLoadingEnd())
    }
}

function* sagaImportProduct(action) {
    try {
        yield put(actions.productLoadingStart())
        yield call(api, url.importProductURL(), 'POST', action.payload)
        const pageNo = yield select(util.getProductsPageNo)
        const size = yield select(util.getProductsSize)
        const payload = { pageNo, size }
        yield put(actions.fetchImportedProducts(payload))
    } catch (e) {
        console.log(e)
        yield put(actions.productLoadingEnd())
    }
}

function* sagaFetchImportedProducts(action) {
    try {
        yield put(actions.productLoadingStart())

        const { data } = yield call(api, url.getImportedProductsURL(), 'POST', action.payload)
        yield put(
            actions.fetchImportedProductsSuccess({
                products_list: data.data,
                count: data.count,
                size: data.size,
                pageNo: data.pageNo,
            })
        )
    } catch (e) {
        console.log('fetch imported products error ', e)
        yield put(actions.productLoadingEnd())
    }
}

function* sagaDeleteImportedProducts(action) {
    try {
        yield put(actions.productLoadingStart())
        const { id, ...rest } = action.payload
        const data = {
            id: id,
        }
        yield call(api, url.deleteImportedProductsURL(), 'POST', data)
        yield put(actions.fetchImportedProducts({ ...rest }))
    } catch (e) {
        console.log('delete imported products error ', e)
        yield put(actions.productLoadingEnd())
    }
}

function* sagaAddNewProduct(action) {
    try {
        yield put(actions.productLoadingStart())
        const { data } = yield call(api, url.addNewProductURL(), 'POST', action.payload)
        yield put(actions.addNewProductSuccess(data))
        history.push({
            pathname: `/dashboard/add-new-products/${data._id}`,
            state: { isProductAdded: true },
        })
    } catch (e) {
        console.log('add new product error ', e)
        yield put(actions.productLoadingEnd())
    }
}

function* updateProductName(action) {
    try {
        yield put(actions.productLoadingStart())
        const currProduct = yield select(util.getProduct)
        const payload = { name: action.payload }
        let { data } = yield call(api, url.patchURL(currProduct._id), 'POST', payload)
        data = helper.mapClonedProduct(data)
        yield put(actions.updateProductNameSuccess(data))
    } catch (e) {
        console.log(' update product name error', e)
        yield put(actions.productLoadingEnd())
    }
}

function* patchProductDetails(action) {
    const { options, payload } = action
    let { sectionKey, missingFields } = options
    try {
        yield put(actions.productLoadingStart())
        if (!sectionKey) {
            new Error('Section key Required to update product details')
        }
        const currProduct = yield select(util.getProduct)
        let { data } = yield call(api, url.patchURL(currProduct._id, sectionKey), 'POST', payload, {
            hasCustomError: true,
        })
        const show_completed_modal = currProduct.setup !== 'complete' && data.setup === 'complete'
        if (!!missingFields) {
            data[sectionKey]['missingFields'] = missingFields
        }
        let productDetails = {
            ...currProduct,
            [sectionKey]: data[sectionKey],
            status: data.status,
            updated_at: data.updated_at,
            product_id: data.product_id,
            setup: data.setup,
            visibility: data.visibility,
            modified_area: data.modified_area,
        }
        productDetails = helper.mapClonedProduct(productDetails)
        if (!!missingFields) {
            sectionKey = ''
        }
        const successPayload = {
            productDetails,
            show_completed_modal,
        }
        yield put(actions.patchProductDetailsSuccess(successPayload, sectionKey))
    } catch (error) {
        console.log('PATCH PRODUCT DETAILS ERROR', error, sectionKey)
        yield put(actions.setProductError(sectionKey))
        yield put(actions.productLoadingEnd())
    }
}

function* updateSectionFlags(action) {
    const {
        payload: { key, flag },
    } = action
    try {
        yield put(actions.productLoadingStart())
        const { _id } = yield select(util.getProduct)
        const flagURL = flag ? url.setSectionFlagURL(_id, key) : url.clearSectionFlagURL(_id, key)
        const { data } = yield call(api, flagURL, 'POST', null, {
            hasCustomError: true,
        })
        console.log('data', data)
        yield put(actions.productLoadingEnd())
        yield put(actions.setSectionFlag(helper.extractSectionFlags(data)))
    } catch (error) {
        console.log('PATCH PRODUCT DETAILS ERROR', error, key)
        yield put(actions.setProductError(key))
        yield put(actions.productLoadingEnd())
    }
}

function* fetchPrimaryCategories() {
    try {
        yield put(actions.optionsLoadingStart('category'))
        const { data } = yield call(api, url.getPrimaryCategoriesURL(), 'GET')
        const currFilters = yield select(util.getManageProductsFilters)
        const currProductFilters = yield select(util.getProductsFilters)

        const updatedFilters = currFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'category_id') {
                cloneFilter['baseFilterList'] = data
            }
            return cloneFilter
        })
        const updatedProductFilters = currProductFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'category_id') {
                cloneFilter['baseFilterList'] = data
            }
            return cloneFilter
        })
        yield put(actions.updateProductsFilters(updatedProductFilters))
        yield put(actions.updateManageUpdatesFilter(updatedFilters))
        yield put(actions.optionsLoadingEnd())
    } catch (e) {
        console.log('Fetch Primary Categories error', e)
        yield put(actions.optionsLoadingEnd())
    }
}

function* fetchDynamicCategories() {
    try {
        yield put(actions.optionsLoadingStart('dynamic_categories'))
        const { data } = yield call(api, url.getDynamicCategoriesURL(), 'GET')
        const currFilters = yield select(util.getManageProductsFilters)
        const currProductFilters = yield select(util.getProductsFilters)

        const updatedFilters = currFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'dynamic_category_id') {
                cloneFilter['baseFilterList'] = data
            }
            return cloneFilter
        })
        const updatedProductFilters = currProductFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'dynamic_category_id') {
                cloneFilter['baseFilterList'] = data
            }
            return cloneFilter
        })
        yield put(actions.updateProductsFilters(updatedProductFilters))
        yield put(actions.updateManageUpdatesFilter(updatedFilters))
        yield put(actions.optionsLoadingEnd())
    } catch (e) {
        console.log('Fetch Dynamic Categories error', e)
        yield put(actions.optionsLoadingEnd())
    }
}

function* fetchTags() {
    try {
        yield put(actions.optionsLoadingStart('tags'))
        const { data } = yield call(api, url.getTagsList(), 'GET')
        const currFilters = yield select(util.getProductsFilters)
        const updatedFilters = currFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'meta_tags') {
                cloneFilter['baseFilterList'] = data
            }
            return cloneFilter
        })
        yield put(actions.fetchTagsSuccess(data))
        yield put(actions.updateProductsFilters(updatedFilters))
        yield put(actions.optionsLoadingEnd())
    } catch (e) {
        console.log('Fetch Tags error', e)
        yield put(actions.optionsLoadingEnd())
    }
}

function* fetchServingSizeUOMs() {
    try {
        yield put(actions.optionsLoadingStart('servingSize'))
        const { data } = yield call(api, url.getServingSizeUOMURL(), 'GET')
        yield put(actions.fetchServingSizeUOMSuccess(data))
        yield put(actions.optionsLoadingEnd())
    } catch (e) {
        console.log('Fetch Tags error', e)
        yield put(actions.optionsLoadingEnd())
    }
}

function* fetchMarketplaces(action) {
    try {
        yield put(actions.productLoadingStart())
        const { country, catalog_type } = action.payload
        const { data } = yield call(api, url.getMarketplacesList(country, catalog_type), 'GET')
        yield put(actions.fetchMarketplacesSuccess({ [catalog_type]: data }))
        yield put(actions.productLoadingEnd())
    } catch (e) {
        console.log('Fetch Marketplaces error', e)
        yield put(actions.productLoadingEnd())
    }
}

function* fetchEquipments() {
    try {
        yield put(actions.optionsLoadingStart('equipment'))
        const { data } = yield call(api, url.getEquipmentsList(), 'GET')
        yield put(actions.fetchEquipmentsSuccess(data))
        yield put(actions.optionsLoadingEnd())
    } catch (e) {
        console.log('Fetch Equipments error', e)
        yield put(actions.optionsLoadingEnd())
    }
}

function* fetchModifiedAreas() {
    try {
        yield put(actions.optionsLoadingStart('modified_area'))
        const { data } = yield call(api, url.getModifiedAreasURL(), 'GET')
        const currFilters = yield select(util.getManageProductsFilters)
        const updatedFilters = currFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'modified_area') {
                cloneFilter['baseFilterList'] = data
            }
            return cloneFilter
        })
        yield put(actions.updateManageUpdatesFilter(updatedFilters))
        yield put(actions.optionsLoadingEnd())
    } catch (e) {
        console.log('Fetch Modified Areas error', e)
        yield put(actions.optionsLoadingEnd())
    }
}

function* publishProduct(action) {
    try {
        yield put(actions.productLoadingStart())
        const payload = {
            env: action.payload,
        }
        const { _id } = yield select(util.getProduct)
        const { data } = yield call(api, url.getPublishURL(_id), 'POST', payload)
        yield put(actions.publishSuccess(data))
    } catch (e) {
        console.log('PUBLISH PRODUCT ERROR', e)
        yield put(actions.productLoadingEnd())
    }
}

function* updatePublishedProduct(action) {
    try {
        yield put(actions.productLoadingStart())
        const isCatalogProduct = history.location.pathname.split('/')[2] === 'products'
        const config = {
            url: !isCatalogProduct
                ? url.getUpdatePublishedProduct(action.payload)
                : url.updateCatalogProductsURL(action.payload),
        }
        const { data } = yield call(api, config.url, 'POST')
        history.push(util.productDetailsURL(data.children_id))
    } catch (e) {
        yield put(actions.productLoadingEnd())
        console.log('UPDATE PUBLISHED PRODUCT', e)
    }
}

function* deleteProduct(action) {
    try {
        yield put(actions.productLoadingStart())
        const {
            data: { deletedCount },
        } = yield call(api, url.getDeleteProductURL(), 'POST', action.payload)

        if (history.location.pathname === constants.routePaths.manage_updates.path) {
            const msg = `${deletedCount} drafts have been successfully deleted`
            let currProducts = yield select(util.getManageUpdatesProducts)
            action.payload.ids.forEach(id => {
                // console.log('currProducts', currProducts, )
                const index = currProducts.findIndex(prod => prod._id === id)
                console.log('product index', index)
                currProducts.splice(index, 1)
            })
            const products = {
                products: currProducts,
                count: currProducts.length,
            }
            yield put(actions.setManageUpdatesAlert(msg))
            yield put(actions.fetchManageUpdatesSuccess(products))
        } else if (deletedCount) {
            history.push(constants.routePaths.manage_updates.path)
        }
    } catch (e) {
        console.log('Delete Product error', e)
        yield put(actions.productLoadingEnd())
    }
}

function* publishProductToQA(product) {
    try {
        const { _id } = product
        const { data } = yield call(
            api,
            url.getPublishURL(_id),
            'POST',
            { env: process.env.REACT_APP_PRODUCTS_PUBLISH_ENV },
            {
                hasCustomError: true,
            }
        )
        return data
    } catch (e) {
        console.log('Bulk Publish Products error', e)
        return product
    }
}

function* bulkPublishProducts(action) {
    yield put(actions.productLoadingStart())
    const publishMultipleProducts = action.payload.map(product => call(publishProductToQA, product))
    const publishedProducts = yield all(publishMultipleProducts)
    let productsList = yield select(util.getManageUpdatesProducts)
    let publishedProductsCount = 0
    let unPublishedProductsList = []
    publishedProducts.forEach(product => {
        if (product.visibility === 'qa') {
            const index = productsList.findIndex(
                originalProduct => originalProduct._id === product._id
            )
            productsList[index] = product
            publishedProductsCount += 1
        } else {
            unPublishedProductsList.push(product.name)
        }
    })
    const payload = {
        products: productsList,
        manage_updates_alert: publishedProductsCount
            ? `${publishedProductsCount} products have been successfully published to QA`
            : '',
        failed_products:
            unPublishedProductsList.length > 0
                ? {
                      list: unPublishedProductsList,
                      message: strings.publishProductsErrorMsg,
                  }
                : null,
    }
    yield put(actions.bulkPublishProductsSuccess(payload))
}

function* fetchManageProducts(action) {
    try {
        const isSideMenuOpened = yield select(util.isSideMenuOpened)
        if (isSideMenuOpened) {
            return
        }
        yield put(actions.productLoadingStart())
        const { search, ...rest } = action.payload
        const payload = {
            filter: search,
            ...rest,
        }
        const { data } = yield call(api, url.fetchManageProductsURL(), 'POST', payload)
        const res = {
            ...data,
            products: data.data,
        }
        delete res.data
        yield put(actions.fetchManageProductsSuccess(res))
    } catch (error) {
        yield put(actions.productLoadingEnd())
        console.log('FETCH MANAGE PRODUCTS ERROR', error)
    }
}

function* fetchProductById(action) {
    try {
        yield put(actions.productLoadingStart())
        let { data } = yield call(api, url.getProductDetailsByID(action.payload), 'GET', {
            hasCustomError: true,
        })
        data = helper.mapClonedProduct(data)
        const payload = {
            productDetails: data,
            isModifiedAreaAutoUpdated: false,
        }
        yield put(actions.fetchProductDetailsSuccess(payload))
        yield put(actions.setSectionFlag(helper.extractSectionFlags(data)))
    } catch (error) {
        yield put(actions.setProductError(strings.PRODUCT_ERROR))
        yield put(actions.productLoadingEnd())
    }
}

function* updateCatalogProduct(product) {
    try {
        let { _id } = product
        const { data } = yield call(api, url.updateCatalogProductsURL(_id), 'POST', '', {
            hasCustomError: true,
        })
        return data
    } catch (e) {
        console.log('Update Catalog Products error', e)
        return product
    }
}

function* bulkUpdateCatalogProducts(action) {
    yield put(actions.productLoadingStart())
    const updateMultipleProducts = action.payload.map((product, i) =>
        call(updateCatalogProduct, product, i)
    )
    const updatedProducts = yield all(updateMultipleProducts)
    let updatedProductsCount = 0
    let failedProductsList = []
    updatedProducts.forEach(product => {
        if (!!product.children_id) {
            updatedProductsCount += 1
        } else {
            failedProductsList.push(product.name)
        }
    })
    const payload = {
        manage_updates_alert: updatedProductsCount
            ? `${updatedProductsCount} product(s) have been successfully added to Manage Updates. Click a product name to start modifying.`
            : '',
        failed_products:
            failedProductsList.length > 0
                ? {
                      list: failedProductsList,
                      message: strings.updateProductsErrorMsg,
                  }
                : null,
    }
    yield put(actions.bulkUpdateCatalogProductsSuccess(payload))
    history.push({
        pathname: constants.routePaths.manage_updates.path,
        state: { isBulkUpdate: true },
    })
}
export default function* watchProducts() {
    yield all([
        takeEvery(actions.actionTypes.SAGA_IMPORT_PRODUCT, sagaImportProduct),
        takeEvery(actions.actionTypes.SAGA_FETCH_IMPORTED_PRODUCTS, sagaFetchImportedProducts),
        takeEvery(actions.actionTypes.SAGA_DELETE_IMPORTED_PRODUCTS, sagaDeleteImportedProducts),
        takeEvery(actions.actionTypes.SAGA_ADD_NEW_PRODUCT, sagaAddNewProduct),
        takeEvery(actions.actionTypes.SAGA_FETCH_PRODUCT_BY_DRAFT_ID, fetchProductByDraftId),
        takeEvery(actions.actionTypes.SAGA_FETCH_PRODUCT_IMAGES, fetchAvailableProductImages),
        takeEvery(actions.actionTypes.SAGA_PATCH_PRODUCT_DETAILS, patchProductDetails),
        takeEvery(actions.actionTypes.SAGA_FETCH_CONTAINS, fetchNutritionContains),
        takeEvery(actions.actionTypes.SAGA_UPDATE_SECTION_FLAG, updateSectionFlags),
        takeEvery(actions.actionTypes.SAGA_FETCH_PRIMARY_CATEGORIES, fetchPrimaryCategories),
        takeEvery(actions.actionTypes.SAGA_FETCH_DYNAMIC_CATEGORIES, fetchDynamicCategories),
        takeEvery(actions.actionTypes.SAGA_FETCH_TAGS, fetchTags),
        takeEvery(actions.actionTypes.SAGA_FETCH_SERVING_SIZE_UOM, fetchServingSizeUOMs),
        takeEvery(actions.actionTypes.SAGA_FETCH_MARKETPLACES, fetchMarketplaces),
        takeEvery(actions.actionTypes.SAGA_UPDATE_PRODUCT_NAME, updateProductName),
        takeEvery(actions.actionTypes.SAGA_FETCH_EQUIPMENTS, fetchEquipments),
        takeEvery(actions.actionTypes.SAGA_DELETE_PRODUCT, deleteProduct),
        takeEvery(actions.actionTypes.SAGA_PUBLISH_PRODUCT, publishProduct),
        takeEvery(actions.actionTypes.SAGA_FETCH_MANAGE_UPDATES, fetchManageUpdates),
        takeEvery(actions.actionTypes.SAGA_UPDATE_PUBLISH_PRODUCT, updatePublishedProduct),
        takeEvery(actions.actionTypes.SAGA_BULK_PUBLISH_PRODUCTS, bulkPublishProducts),
        takeEvery(actions.actionTypes.SAGA_FETCH_MODIFIED_AREAS, fetchModifiedAreas),
        takeEvery(actions.actionTypes.SAGA_FETCH_MANAGE_PRODUCTS, fetchManageProducts),
        takeEvery(actions.actionTypes.SAGA_FETCH_PRODUCT_BY_ID, fetchProductById),
        takeEvery(actions.actionTypes.SAGA_BULK_UPDATE_CATALOG_PRODUCTS, bulkUpdateCatalogProducts),
    ])
}
